import useTenantName, { UNKNOWN_TENANT_NAME } from '@lib/hooks/useTenantName';
import { TaskText } from '@components/Task/TaskText';
import { getTestIdProps } from '@lib/testUtils';
import styles from './TaskTenantName.module.css';

type TenantNameProps = {
  'data-testid'?: string;
  tenantNameOrId: string;
};

export const TaskTenantName = ({
  tenantNameOrId,
  'data-testid': dataTestId,
}: TenantNameProps) => {
  const name = useTenantName(tenantNameOrId);

  if (name === UNKNOWN_TENANT_NAME) {
    return null;
  }

  return (
    <TaskText
      text={name}
      tooltip={name}
      className={styles.tenantName}
      {...getTestIdProps(dataTestId)}
    />
  );
};
